import React, { Component } from "react";
import { Form, DatePicker, TimePicker, InputNumber } from "antd";
import { observer, inject } from "mobx-react";

const FormItem = Form.Item;

const formItemLayout = {
	labelCol: { span: 2 },
	wrapperCol: { span: 10 }
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class ScheduleForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	render() {
		return (
			<Form>
				<FormItem {...formItemLayout} label="Start Date">
					{this.props.form.getFieldDecorator("startDate", {
						rules: [
							{
								required: true,
								message: "Start date is required"
							}
						]
					})(<DatePicker />)}
				</FormItem>
				<FormItem {...formItemLayout} label="Start Time">
					{this.props.form.getFieldDecorator("startDate", {
						rules: [
							{
								required: true,
								message: "Start time is required"
							}
						]
					})(<TimePicker format={"HH:mm"} />)}
				</FormItem>
				<FormItem {...formItemLayout} label="Duration">
					{this.props.form.getFieldDecorator("nDay", {
						rules: [
							{
								required: true,
								message: "Please choose a number of days to run"
							},
							{
								type: "integer",
								range: {
									min: 1
								},
								message: "Number of days must be greater than 0"
							}
						]
					})(<InputNumber min={1} />)}
					<span className="ant-form-text">{' '}days</span>
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class ScheduleTab extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	onFieldsChange = changedFields => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		xwizardStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { xwizardStore }
		} = this.props;
		const stateForm = xwizardStore.stateForm;

		let fields = {
			startDate: Form.createFormField(stateForm.startDate),
			nDay: Form.createFormField(stateForm.nDay)
		};
		return fields;
	};
	render() {
		const fields = this.mapPropsToFields();

		return (
			<ScheduleForm
				fields={fields}
				onFieldsChange={this.onFieldsChange}
				wrappedComponentRef={internalForm => {
					if (internalForm != null) {
						this.internalForm = internalForm;
					}
				}}
			/>
		);
	}
}

export default ScheduleTab;
